import { render, staticRenderFns } from "./OrganizationPhoneInput.vue?vue&type=template&id=580e5419&"
import script from "./OrganizationPhoneInput.vue?vue&type=script&lang=js&"
export * from "./OrganizationPhoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports